<template>
  <section id="contact" class="grid md:grid-cols-2">
    <div class="md:self-end md:pr-8 lg:pr-16">
      <h2 class="mb-1 v-highlight text-h2">
        <router-link class="header-anchor" :to="{ hash: '#contact' }"
          >Contact</router-link
        >
      </h2>
      <h3 class="py-2 text-h4 text-secondary">Let's work together</h3>
      <p class="py-2">
        Frontend was like a box of chocolates. You never know what you're gonna
        get.
      </p>
    </div>
    <div id="contacts" class="my-4 md:self-start md:pr-8 lg:pr-16">
      <div id="location" class="flex items-center py-2">
        <p class="pl-4">Taiwan New Taipei City</p>
      </div>
      <div id="mail" class="flex items-center py-2">
        <p class="pl-4">louiskoxiang@gmail.com</p>
      </div>
      <div id="gitHub" class="flex items-center py-2">
        <p class="pl-4">https://github.com/LouisKoXiang</p>
      </div>
      <div id="gitHub" class="flex items-center py-2">
        <p class="pl-4">https://www.linkedin.com/in/jing-xiang-ko-a837a0177/</p>
      </div>
    </div>
  </section>
</template>
